import { Routes, Route } from "react-router-dom";
import App from './App';
import Attendance from './Attendance/Attendance.jsx';
import Ambassador from './Ambassador/Ambassador.jsx';
import FormConfirmation from "./FormConfirmation/Index.jsx";
import FormConfirmationDiscount from "./FormConfirmationDiscount/Index.jsx";
import { Guide } from "./Guide/guide.jsx";
import { GuideCity } from "./Guide/guidecity.jsx";
import ClaimTicket from "./ClaimTicket/ClaimTicket.jsx";


const RouteEdufest = () => {
    return (
        <Routes>
            <Route path='/' element={<App />} />
            <Route path='/attendance' element={<Attendance />} />
            <Route path='/ambassador' element={<Ambassador />} />
            <Route path="/form-confirmation" element={<FormConfirmation />} />
            <Route path="/form-confirmation-event" element={<FormConfirmationDiscount />} />
            <Route path="/claim-ticket" element={<ClaimTicket />} />
            <Route path='/guide' element={<Guide />} />
            <Route path='/guide/:city' element={<GuideCity />} />
        </Routes>
    )
}

export default RouteEdufest
